import React, { useState, useEffect } from "react";

import { CDataTable, CBadge } from "@coreui/react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";

import URL from "../../../config/api";
import axios from "../../../config/axios";

import "./styles.css";

const getBadgeColor = status => {
  switch (status) {
    case "Enviado":
      return "success";
    case "Pendente":
      return "warning";
    case "Prazo Excedido":
      return "danger";
    default:
      return "primary";
  }
};

const StudentStatusTable = props => {
  const { roomId, disciplinaId } = props;
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = useSelector(state => state.user.token);
  const history = useHistory();

  const fields = [
    { key: "nome", label: "Nome do estudante", _style: { width: "70%" } },
    {
      key: "status",
      label: "Status",
      _style: { width: "30%", verticalAlign: "middle" },
      _classes: "text-center"
    }
  ];

  useEffect(() => {
    const classId = roomId?.roomId;
    if (classId) {
      setLoading(true);

      // Aguardar o End Point do back.
      let apiUrl = `${URL.api}pedagogical-follow-up/status-by-room/${classId}`;
      if (disciplinaId) {
        apiUrl += `?disciplinaId=${disciplinaId}`;
      }

      axios
        .get(apiUrl, {
          headers: { authorization: `Bearer ${token}` }
        })
        .then(resp => {
          setUsersData(resp.data.data);
        })
        .catch(error => {
          console.error("Erro ao buscar status dos estudantes:", error);
          toastr.error(
            "Erro",
            "Não foi possível carregar os dados dos estudantes."
          );
          setUsersData([]); // Limpa os dados em caso de erro
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [roomId, disciplinaId, token]);

  const handleStudentClick = studentId => {
    history.push(`/pedagogical-follow-ups/execution/${studentId}`);
  };

  return (
    <CDataTable
      items={usersData}
      fields={fields}
      loading={loading}
      hover
      noItemsViewSlot={
        <div className="text-center p-4">
          {loading ? (
            <p>Carregando dados...</p>
          ) : (
            <p>Nenhum estudante encontrado para os filtros selecionados.</p>
          )}
        </div>
      }
      scopedSlots={{
        nome: item => (
          <td
            onClick={() => handleStudentClick(item.id)}
            className="student-name-clickable"
            style={{ cursor: "pointer", color: "#321fdb", fontWeight: "500" }}
          >
            {item.nome}
          </td>
        ),
        status: item => (
          <td className="text-center" style={{ verticalAlign: "middle" }}>
            <CBadge color={getBadgeColor(item.status)}>{item.status}</CBadge>
          </td>
        )
      }}
    />
  );
};

export default StudentStatusTable;
